<div class="container col-lg-12  pl-3">
    <!-- Titre -->

    <dd style="margin-bottom: 4px"><b>Document</b></dd>

    <div class="row mb-2" *ngIf="loadingSettings">
        <div class="col-12">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span class="ml-2 size13">Chargement des paramètres…</span>
        </div>
    </div>

    <!-- Modèles -->
    <div class="row mb-1" style="height: 215px;">
        <div class="card-model p-2 col-lg-2 col-xl-2 mt-2 mb-2 ml-0" [class.card-selected]="selectedDocModel === 1" (click)="selectedDocModel = 1">
            <p class="size15" style="color: #2F2B3DE5">Mod&egrave;le 1</p>
            <div class="org-radio-wrapper">
                <input type="radio" name="refStatic" id="refStatic1" value="1" [checked]="selectedDocModel === 1" (change)="selectedDocModel = 1" class="org-radio-input">
                <label class="org-radio-label" for="refStatic1"><span class="org-radio-dot"></span></label>
            </div>
        </div>

        <div class="card-model p-2 col-lg-2 col-xl-2 m-2" [class.card-selected]="selectedDocModel === 2" (click)="selectedDocModel = 2">
            <p class="size15" style="color: #2F2B3DE5">Mod&egrave;le 2</p>
            <div class="org-radio-wrapper">
                <input type="radio" name="refStatic" id="refStatic2" value="2" [checked]="selectedDocModel === 2" (change)="selectedDocModel = 2" class="org-radio-input">
                <label class="org-radio-label" for="refStatic2"><span class="org-radio-dot"></span></label>
            </div>
        </div>
    </div>

    <!-- Langue -->
    <div class="row mb-2">
        <div class="col-lg-4 pl-0">
            <dd class="mb-1"><b>Langue du document</b></dd>
            <select class="form-control" name="langueDocument" [(ngModel)]="selectedLangue">
                <option [ngValue]="'francais'">Français</option>
                <option [ngValue]="'anglais'">Anglais</option>
                <option [ngValue]="'arabe'">Arabe</option>
            </select>
        </div>
    </div>

    <!-- Génération bon de livraison -->
    <div class="row mb-2">
        <div class="col-12 pl-0">
            <dd class="mb-1"><b>Activer la génération automatique d'un bon de livraison</b></dd>
            <div class="pd-radio-row">
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="livraison" id="livraisonOui" value="oui" [(ngModel)]="selectedLivraison" (ngModelChange)="onLivraisonChange()" class="org-radio-input" [disabled]="savingActiveBonLiv || loadingSettings">
                        <label class="org-radio-label" for="livraisonOui"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="livraisonOui">Oui</label>
                </div>
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="livraison" id="livraisonNon" value="non" [(ngModel)]="selectedLivraison" (ngModelChange)="onLivraisonChange()" class="org-radio-input" [disabled]="savingActiveBonLiv || loadingSettings">
                        <label class="org-radio-label" for="livraisonNon"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="livraisonNon">Non</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Mettre à jour le prix d'achat sur la fiche produit -->
    <div class="row mb-2">
        <div class="col-12 pl-0">
            <dd class="mb-1"><b>Ajouter le prix d'achat dans le produit</b></dd>
            <div class="pd-radio-row">
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="majPrixAchatProduit" id="majPrixAchatOui" value="oui" [(ngModel)]="selectedMajPrixAchatProduit" (ngModelChange)="onMajPrixAchatProduitChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="majPrixAchatOui"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="majPrixAchatOui">Oui</label>
                </div>
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="majPrixAchatProduit" id="majPrixAchatNon" value="non" [(ngModel)]="selectedMajPrixAchatProduit" (ngModelChange)="onMajPrixAchatProduitChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="majPrixAchatNon"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="majPrixAchatNon">Non</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Base de calcul du prix d'achat (CMUP facture fournisseur) -->
    <div class="row mb-2">
        <div class="col-12 pl-0">
            <dd class="mb-1"><b>Fixer la base de calcul du prix d'achat</b></dd>
            <div class="pd-radio-row">
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="baseCalculPrixAchat" id="baseCalculProduit" [value]="'produit'" [(ngModel)]="selectedBaseCalculPrixAchat" (ngModelChange)="onBaseCalculPrixAchatChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="baseCalculProduit"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="baseCalculProduit">Prix d'achat enregistré sur le produit</label>
                </div>
                <div class="pd-radio-option">
                    <div class="org-radio-wrapper" style="padding: 0;">
                        <input type="radio" name="baseCalculPrixAchat" id="baseCalculDocument" [value]="'document_achat'" [(ngModel)]="selectedBaseCalculPrixAchat" (ngModelChange)="onBaseCalculPrixAchatChange()" class="org-radio-input" [disabled]="savingPrixAchatOpts || loadingSettings">
                        <label class="org-radio-label" for="baseCalculDocument"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 mb-0" for="baseCalculDocument">Prix d'achat sur le document d'achat</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Cachet sur document -->
    <div class="row mb-1">
        <div class="col-12 pl-0">
            <dd class="mb-1"><b>Afficher un cachet sur les documents</b></dd>

            <div
                    class="card card-document-input text-center p-3"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    [class.drag-active]="isDragging"
            >
                <!-- Icône -->
                <label for="fileInput" class="cursor-pointer d-block mb-2">
                    <button class="unstyled-btn">
                        <i data-feather="upload" [size]="18"></i>
                    </button>

                </label>

                <!-- Input file caché -->
                <input
                        #fileInputCachet
                        id="fileInput"
                        type="file"
                        accept="image/*,.pdf"
                        (change)="onFileSelected($event)"
                        hidden
                />
                <dd *ngIf="!fileUrl" style="font-size: 16px; color: #2F2B3DE5">Déposez votre image ici <br></dd>
                <span style="text-align: center">ou</span>
                <!-- Message ou aperçu -->
                <button type="button" class="ml-3 unstyled-btn2" (click)="triggerFileInput(fileInputCachet)">
                    Parcouriez votre image
                </button>


                <img
                        *ngIf="fileUrl && isImage"
                        [src]="fileUrl"
                        alt="Aperçu du fichier"
                        class="img-fluid mt-2"
                />

                <iframe
                        *ngIf="fileUrl && isPdf"
                        [src]="fileUrl"
                        width="100%"
                        height="200px"
                        class="mt-2"
                ></iframe>
            </div>
        </div>
    </div>


    <!-- Référence du document (par type) -->
    <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap">
        <dd class="mb-0"><b>Référence du document</b></dd>
        <button
            type="button"
            class="btn btn-primary btn-sm waves-effect pd-ref-add-btn"
            (click)="openAddReferenceModelModal()"
            [disabled]="loadingReferenceModels || savingReferenceModel || loadingSettings">
            + Ajouter un modèle ({{ selectedRefDocTypeLabel }})
        </button>
    </div>

    <ul class="nav nav-tabs pd-ref-type-nav mb-2">
        <li class="nav-item" *ngFor="let t of refDocTypeMenu">
            <a
                class="nav-link"
                href="javascript:void(0)"
                [class.active]="selectedRefDocTypeId === t.typeDocumentId"
                [class.disabled]="loadingReferenceModels || savingReferenceModel || loadingSettings"
                (click)="!(loadingReferenceModels || savingReferenceModel || loadingSettings) && selectRefDocType(t.typeDocumentId)">
                {{ t.label }}
            </a>
        </li>
    </ul>

    <div class="row mb-1" *ngIf="loadingReferenceModels">
        <div class="col-12 p-2">
            <span class="spinner-border spinner-border-sm" role="status"></span> Chargement des modèles...
        </div>
    </div>
    <div class="mb-1" *ngIf="!loadingReferenceModels && referenceModelsForSelectedType.length > 0">
        <div class="pd-ref-models-wrap">
            <div
                #refModelsTrack
                class="pd-ref-models-track"
                (pointerdown)="onRefModelsPointerDown($event)"
                (pointermove)="onRefModelsPointerMove($event)"
                (pointerup)="onRefModelsPointerUp()"
                (pointercancel)="onRefModelsPointerUp()">
                <div
                    *ngFor="let model of referenceModelsForSelectedType"
                    class="pd-ref-model-card card-model"
                    [class.card-selected]="isReferenceModelSelected(model)"
                    (click)="selectReferenceModel(model, $event)"
                    [class.pe-none]="savingReferenceModel || loadingSettings">
                    <p class="size15" style="color: #2F2B3DE5">Mod&egrave;le {{ model.model_type }}</p>
                    <span class="size13">{{ getReferenceFormat(model) }}</span><br/>
                    <span class="size13 text-muted" *ngIf="model.type_document_id == null">Partagé</span>
                    <div class="org-radio-wrapper">
                        <input
                            type="radio"
                            [name]="'refDocModel-' + selectedRefDocTypeId"
                            [id]="'ref-' + selectedRefDocTypeId + '-' + model.id"
                            [value]="model.id"
                            [checked]="isReferenceModelSelected(model)"
                            class="org-radio-input"
                            [disabled]="savingReferenceModel || loadingSettings">
                        <label
                            class="org-radio-label"
                            [attr.for]="'ref-' + selectedRefDocTypeId + '-' + model.id"
                            (click)="$event.preventDefault()">
                            <span class="org-radio-dot"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-1" *ngIf="!loadingReferenceModels && referenceModelsForSelectedType.length === 0">
        <div class="col-12 p-2 text-muted">Aucun modèle pour {{ selectedRefDocTypeLabel }}. Ajoutez-en un avec le bouton ci-dessus.</div>
    </div>

    <ng-template #refModelModal let-modal>
        <div class="modal-header bg-white py-2">
            <button type="button" class="close" (click)="closeRefModelModal()" [disabled]="savingCustomRefModel">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body p-0">
            <div class="pd-ref-modal-body">
                <div class="text-center mb-3">
                    <p class="pd-ref-modal-title mb-1">Nouveau modèle — {{ selectedRefDocTypeLabel }}</p>
                    <p class="mb-0 text-muted size13">Ajoutez les éléments un par un — aperçu instantané</p>
                </div>

                <!-- Une seule ligne d’actions -->
                <div class="pd-ref-toolbar mb-2">
                    <select class="form-control pd-ref-toolbar__select" [(ngModel)]="refPickType" (ngModelChange)="onRefPickTypeChange()" [disabled]="savingCustomRefModel">
                        <option value="">+ Ajouter…</option>
                        <option value="text">Texte</option>
                        <option value="date">Date</option>
                        <option value="PREFIX">Préfixe doc</option>
                        <option value="STATION">Code station</option>
                        <option value="ETAB">Code établissement</option>
                        <option value="ENT">Code entreprise</option>
                        <option value="SEQ">Compteur</option>
                        <option value="sep">Séparateur</option>
                    </select>

                    <select class="form-control pd-ref-toolbar__select" [(ngModel)]="refAutoSep" [disabled]="savingCustomRefModel" title="Séparateur entre chaque ajout">
                        <option value="-">Sép. -</option>
                        <option value="/">Sép. /</option>
                        <option value="_">Sép. _</option>
                        <option value=" ">Sép. espace</option>
                        <option value="">Sép. aucun</option>
                    </select>

                    <select class="form-control pd-ref-toolbar__select" [(ngModel)]="refSeqPadding" [disabled]="savingCustomRefModel" title="Chiffres du compteur">
                        <option [ngValue]="1">Cpt 1</option>
                        <option [ngValue]="2">Cpt 2</option>
                        <option [ngValue]="3">Cpt 3</option>
                        <option [ngValue]="4">Cpt 4</option>
                        <option [ngValue]="5">Cpt 5</option>
                        <option [ngValue]="6">Cpt 6</option>
                    </select>
                </div>

                <!-- Texte : input apparaît -->
                <div class="pd-ref-inline-panel mb-2" *ngIf="refPickType === 'text'">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Écrire le texte… Ex: Fact"
                        [(ngModel)]="refFreeText"
                        (keyup.enter)="confirmRefPick()"
                        [disabled]="savingCustomRefModel"
                        maxlength="40"
                        autofocus
                    />
                    <button type="button" class="btn btn-primary" (click)="confirmRefPick()" [disabled]="savingCustomRefModel || !refFreeText?.trim()">OK</button>
                    <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="refPickType = ''" [disabled]="savingCustomRefModel">✕</button>
                </div>

                <!-- Date : dropdown format -->
                <div class="pd-ref-inline-panel mb-2" *ngIf="refPickType === 'date'">
                    <select class="form-control" [(ngModel)]="refDateFormat" [disabled]="savingCustomRefModel">
                        <option *ngFor="let opt of refDateOptions" [ngValue]="opt.value">{{ opt.label }}</option>
                    </select>
                    <button type="button" class="btn btn-primary" (click)="confirmRefPick()" [disabled]="savingCustomRefModel">OK</button>
                    <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="refPickType = ''" [disabled]="savingCustomRefModel">✕</button>
                </div>

                <!-- Séparateur manuel -->
                <div class="pd-ref-inline-panel mb-2" *ngIf="refPickType === 'sep'">
                    <select class="form-control" [(ngModel)]="refManualSep" [disabled]="savingCustomRefModel">
                        <option value="-">Tiret -</option>
                        <option value="/">Slash /</option>
                        <option value="_">Underscore _</option>
                        <option value=" ">Espace</option>
                        <option value=".">Point .</option>
                    </select>
                    <button type="button" class="btn btn-primary" (click)="confirmRefPick()" [disabled]="savingCustomRefModel">OK</button>
                    <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="refPickType = ''" [disabled]="savingCustomRefModel">✕</button>
                </div>

                <div class="pd-ref-chips mb-3" *ngIf="refBuilderParts.length; else emptyParts">
                    <span class="pd-ref-chip" [class.pd-ref-chip--sep]="part.kind === 'sep'" *ngFor="let part of refBuilderParts; let i = index">
                        <button type="button" class="pd-ref-chip-move" (click)="moveRefPart(i, -1)" [disabled]="savingCustomRefModel || i === 0">‹</button>
                        <span>{{ part.label || part.value || part.kind }}</span>
                        <button type="button" class="pd-ref-chip-move" (click)="moveRefPart(i, 1)" [disabled]="savingCustomRefModel || i === refBuilderParts.length - 1">›</button>
                        <button type="button" class="pd-ref-chip-remove" (click)="removeRefPart(i)" [disabled]="savingCustomRefModel">&times;</button>
                    </span>
                </div>
                <ng-template #emptyParts>
                    <div class="text-muted size13 mb-3">Choisissez un élément dans « + Ajouter… »</div>
                </ng-template>

                <div class="pd-ref-preview mb-3">
                    <div class="size13 text-muted mb-1">Aperçu</div>
                    <div class="pd-ref-preview-value">{{ refBuilderPreview || '—' }}</div>
                    <div class="pd-ref-preview-hint size13 text-muted mt-1" *ngIf="refBuilderParts.length">
                        Station {{ previewStationCode }} · Établissement {{ previewEtabCode }} · Entreprise {{ previewEntrepriseCode }}
                    </div>
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-primary mr-2" (click)="saveCustomReferenceModel()" [disabled]="savingCustomRefModel">
                        <span *ngIf="savingCustomRefModel" class="spinner-border spinner-border-sm mr-1"></span>
                        Valider
                    </button>
                    <button type="button" class="btn btn-default" style="background-color: #80839029;" (click)="closeRefModelModal()" [disabled]="savingCustomRefModel">Annuler</button>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Paramétrage -->
    <dd class="mb-1 "><b>Paramétrage des documents</b></dd>
    <div class="row mb-5 justify-content-start">
        <div class="col-lg-5 card-modelBig p-2 mr-2" [class.card-selected]="selectedDocType === 'achat'" (click)="selectDocTypeAndGo('achat')">
            <div class="d-flex justify-content-center mb-2">
                <i data-feather="shopping-cart" [size]="30"></i>
            </div>
            <span style="font-size: 18px;">Achat</span>
            <p>Paramétrer les documents d’achat</p>
            <div class="org-radio-wrapper ">
                <input type="radio" name="type" id="typeAchat" value="achat" [(ngModel)]="selectedDocType" (change)="goToDocumentAchat()" class="org-radio-input">
                <label class="org-radio-label" for="typeAchat"><span class="org-radio-dot"></span></label>
            </div>
        </div>

        <div class="col-lg-5 card-modelBig p-2" [class.card-selected]="selectedDocType === 'vente'" (click)="selectDocTypeAndGo('vente')">
            <div class="d-flex justify-content-center mb-2">
                <i data-feather="dollar-sign" [size]="30"></i>
            </div>
            <span style="font-size: 18px;">Vente</span>
            <p>Paramétrer les documents de vente</p>
            <div class="org-radio-wrapper ">
                <input type="radio" name="type" id="typeVente" value="vente" [(ngModel)]="selectedDocType" (change)="goToDocumentVente()" class="org-radio-input">
                <label class="org-radio-label" for="typeVente"><span class="org-radio-dot"></span></label>
            </div>
        </div>
    </div>

    <div class="row mb-4 mt-2">
        <div class="col-12 justify-content-end">
            <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    (click)="saveParametreDocument()"
                    [disabled]="saving || loadingSettings || stationId === 0">
                {{  'Enregistrer' }}
            </button>
        </div>
    </div>
</div>
